import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { DxDataGridComponent, DxDropDownBoxComponent } from 'devextreme-angular';
import { DispatchTransporteurDto } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-dispatch-transporteur-select',
  templateUrl: './dispatch-transporteur-select.component.html',
  styleUrls: ['./dispatch-transporteur-select.component.css']
})
export class DispatchTransporteurSelectComponent implements OnInit {
  @ViewChild('dxDropDown') dropDown: DxDropDownBoxComponent;
  @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
  @Select(ControlPanelStore.dispatchTransporteurs$) dispatchTransporteurs$: Observable<DispatchTransporteurDto[]>;

  @Input() width: number;
  @Input() disabled: boolean = false;
  @Input() dispatchTransporteurId: number;
  @Output() dispatchTransporteurIdChange = new EventEmitter<number>();

  @Input() cell: any;

  InitId = null;

  DispatchTransporteurs: DispatchTransporteurDto[] = [];
  SelectedDispatchTransporteur: DispatchTransporteurDto = null;
  ColumnName = [];

  dt: Subscription;

  constructor(private panelLayoutService: PanelLayoutService,
    private translate: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
    // Instanciate Globalize for DevExtreme components
    this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());

    this.translate.get(
      [
        'Identifiant'
      ]
    ).subscribe(translations => {
      this.ColumnName.push(translations['Identifiant']);
    });
  }

  ngOnInit() {
    if (this.dispatchTransporteurId != null) {
      this.InitId = JSON.parse(JSON.stringify(this.dispatchTransporteurId));
    }

    this.dt = this.dispatchTransporteurs$.subscribe(res => {
      if (res != null) {
        this.DispatchTransporteurs = res;
      }
    });
  }

  ngOnDestroy() {
    this.dt?.unsubscribe();
  }

  updateInfo(event) {
    this.dispatchTransporteurId = event.currentSelectedRowKeys.length === 1 ? event.currentSelectedRowKeys[0].Id : this.dispatchTransporteurId;
    if (!!this.cell && this.InitId !== this.dispatchTransporteurId) {
      this.cell.setValue(this.dispatchTransporteurId);
    }
    this.dispatchTransporteurIdChange.emit(this.dispatchTransporteurId);

    if(this.dispatchTransporteurId != null) {
      this.dropDown.instance.close();
    }
  }

  onOpened() {
    if(this.dispatchTransporteurId == null) {
      this.dataGrid.instance.clearSelection();
    }
  }
}
